import { render, staticRenderFns } from "./cModalDoctor.vue?vue&type=template&id=d2c1098a"
import script from "./cModalDoctor.vue?vue&type=script&lang=js"
export * from "./cModalDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports